import { IUniConfig } from "../../uni-base-module"
import angular from "angular"
import { $uniDebug } from "../uni-debug.module"

interface TScope extends ng.IScope {
    toggleShowDev($ev: Event): void
}

class BugToggleBtnDirective implements ng.IDirective {
    restrict: "A"
    scope: {
        path: "@"
    }
    priority: number = -900
    activo: boolean

    constructor(
        private $log: ng.ILogService,
        private $timeout: ng.ITimeoutService,
        private UniConfig: IUniConfig
    ) {
        this.restrict = "A"
        this.scope = {
            path: "@"
        }
    }

    compile(element: JQLite, attrs: ng.IAttributes) {
        this.$log.debug("******** Compile BugToggleBtnDirective", element.html())

        if (!this.UniConfig.debug) {
            attrs.jsonDev = ""
            element.removeAttr("json-dev")
            element.empty()
        }

        this.activo = this.UniConfig.debug

        return this.link
    }

    link(scope: TScope, element: JQLite, attrs: ng.IAttributes, ctrls: ng.IController) {
        scope.toggleShowDev = ($event: Event) => {
            this.$log.info("click!!")
            $event.stopImmediatePropagation()

            this.activo = !this.activo

            angular.element("body").toggleClass("hide__dev", !this.activo)
        }
    }

    template() {
        return `<div if-dev class="item dropdown if-dev-noborder">
<span ng-click="toggleShowDev($event)" class="badge badge-counter glyphaction">&nbsp;</span>
<a target="_self" href="{{::path}}?_dev=0" title="Debug mode"> <i class="fa fa-bug icon-md"></i> </a>
</div>`
    }
}

$uniDebug.directive("bugToggleBtn", [
    "$log",
    "$timeout",
    "UniConfig",
    ($log, $timeout, UniConfig) =>
        new BugToggleBtnDirective($log, $timeout, UniConfig)
])
